import type { AxiosPromise } from 'axios';

import request from '@app/utils/request';

import type { GetSnapshots, PaginationData, Snapshot } from './types';

export const getAllSnapshots = (projectId: string, paginationData?: PaginationData): AxiosPromise<GetSnapshots> =>
    request({
        method: 'GET',
        url: `/project/${projectId}/snapshots`,
        params: paginationData,
    });

export const setAutomaticUploadCall = (projectId: string, enabled: boolean): AxiosPromise =>
    request({
        method: 'PUT',
        url: `/project/${projectId}/snapshots/settings/upload`,
        data: {
            enabled,
        },
    });

export const setAutomaticUpdateCall = (projectId: string, enabled: boolean): AxiosPromise =>
    request({
        method: 'PUT',
        url: `/project/${projectId}/snapshots/settings/auto`,
        data: {
            enabled,
        },
    });

export const setAutomaticBulkActionsCall = (projectId: string, enabled: boolean): AxiosPromise =>
    request({
        method: 'PUT',
        url: `/project/${projectId}/snapshots/settings/bulk`,
        data: {
            enabled,
        },
    });

export const updateSnapshotCall = (projectId: string, snapshotCreatedAt: number, description: string): AxiosPromise =>
    request({
        method: 'PATCH',
        url: `/project/${projectId}/snapshots/${snapshotCreatedAt}`,
        data: {
            description,
        },
    });

export const restoreSnapshotCall = (projectId: string, snapshotCreatedAt: number): AxiosPromise =>
    request({
        method: 'POST',
        url: `/project/${projectId}/snapshots/${snapshotCreatedAt}`,
    });

export const deleteSnapshotCall = (projectId: string, snapshotCreatedAt: number): AxiosPromise =>
    request({
        method: 'DELETE',
        url: `/project/${projectId}/snapshots/${snapshotCreatedAt}`,
    });

export const deleteSnapshotsCall = (projectId: string, snapshotsCreatedAt: number[]): AxiosPromise =>
    request({
        method: 'DELETE',
        url: `/project/${projectId}/snapshots`,
        data: {
            snapshotIds: snapshotsCreatedAt,
        },
    });

export const createSnapshotCall = (projectId: string): AxiosPromise<Snapshot> =>
    request({
        method: 'POST',
        url: `/project/${projectId}/snapshots`,
    });
